import { gql } from '__generated__';

export const ProductFieldsFragment = gql(`
  fragment ProductFields on Product {
    id
    title
    description
    instructions
    image {
      id
      url
    }
    product_variants {
      id
      title
      capacity
      deletable
      sold_count
      active
      locale
      translations {
        ...TranslationFields
      }
    }
    standard_promotion {
      id
      title
      capacity
      amount
      vat_percentage
      start_date
      end_date
      standard
      active
      sold_count
      deletable
    }
    promotions {
      id
      title
      capacity
      amount
      vat_percentage
      start_date
      end_date
      standard
      active
      invitation_reservations_count
      sold_count
      deletable
      locale
      restricted_to_tickets {
        id
        title
      }
      restricted_to_promotions {
        id
        title
      }
      translations {
        ...TranslationFields
      }
    }
    products {
      id
      title
    }
    participant_fields {
      id
    }
    hide_on_invoice
    stand_alone
    vat_percentage
    capacity
    product_variant_capacity
    min_per_order
    max_per_order
    required
    max_per_ticket
    type
    allow_down_payments
    ledger_account
    sold_count
    active
    deletable
    is_sold_out
    locale
    translations {
      ...TranslationFields
    }
  }
`);

export default gql(`
  query GetProduct($event_id: ID!, $product_id: ID!) {
    product(id: $product_id) {
      ...ProductFields
    }
    event(id: $event_id) {
      id
      title
      logo {
        id
        url
      }
      confirmation_mail_text
      brand_color
      locale
      vat_number
      tickets {
        id
        title
        active
        promotions {
          id
          title
          active
        }
      }
      products {
        id
        title
        type
      }
    }
  }
`);
